import CodeEnforcementEntries from "../docs-archive-elements/CodeEnforcementEntries";

export default function CodeDetails() {
    return (
      <div>
<div className="mbhistoric-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Code Enforcement</h2>
</div>

{/*End Large Image Space*/}
{/*Start Main Content*/}
<div className="content-fluid">

    <div className="mb-960-center-container mid-side-outlines">
        {/*Full Width Element*/}
        <div className="mb-960-col-50p left-side-col-50p">

            <h4>Contact</h4>
            <h4>Barry Isett &amp; Associates, Inc.</h4>
            <a href="tel:4848613468"><i className="fa-solid fa-phone"></i>&nbsp;484-861-3468</a>
            <hr/>

             {/*Accordion Start*/}
             <div className="container accordion-container">
                <div className="accordion" id="CodeDidYouKnow">
                {/* Item Start */}
                <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseGrass"
                      >
                        <div>
                          <i
                            className="fa-solid fa-seedling fa-2xl feature-icon af-icon"
                            
                          ></i>
                        </div>

                        <div>
                          <b>Lawn Maintence</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapseGrass"
                      className="accordion-collapse collapse"
                      data-bs-parent="#CodeDidYouKnow"
                    >
                      <div className="accordion-body">
                        <p>
                         Grass &amp; weeds on a property cannot exceed ten inches per Borough ordinance.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start */}
                   <a href="rental">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button">
                        <div>
                          <i className="fa-solid fa-house-circle-check fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Residential Rental License Permit Program</b>
                        </div>
                      </button>
                    </h2>
                    
                  </div>
                  </a>
                  {/* Item Finish */}
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSidewalk"
                      >
                        <div>
                          <i
                            className="fa-solid fa-person-walking fa-2xl feature-icon af-icon"
                            
                          ></i>
                        </div>

                        <div>
                          <b>&nbsp;Sidewalk Information</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapseSidewalk"
                      className="accordion-collapse collapse"
                      data-bs-parent="#CodeDidYouKnow"
                    >
                      <div className="accordion-body">
                        <p>
                         A property owner is responsible for the condition of the sidewalk in front of, and on the side of, their property.  These sidewalks must be swept clean and kept free of snow and ice, etc.
                        </p>
                        <p>
                            The patch of ground between a sidewalk and the road is to be maintained by the propery owner.  A property owner must receive permission to remove or plant any tree on this section of ground.  If you have any questions, please call the Borough
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                   
                   </div>
                   </div>
                   {/*Accordion End*/}


        </div>
        <div className="mb-960-col-50p mobile-pad-1em">

            <h4>Related Documents</h4>
            <CodeEnforcementEntries />
            <br/>

        </div>
    </div>

        


</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
</div>


        </div>
    )
}

 